/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import React, { useContext, useEffect } from 'react';
import { Box, Card, CardContent, Typography, Modal, Grid, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import modalIcon from '../../images/SimpleModalDone.svg';
import { SaveContinueModalStyles as classes } from './SaveContinueModalStyles';

const SimpleTextModal = () => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);

  const { continueModal, setContinueModal } = leadGenerationContext;
  const [open, setOpen] = React.useState(true);
  useEffect(() => {
    continueModal ? setOpen(true) : setOpen(false);
  }, [continueModal]);

  const handleConti = () => {
    setContinueModal(false);
    setOpen(false);
  };

  return (
    <Modal
      sx={classes.backdrop}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(233, 233, 235, 0.78)',
        },
      }}
      open={open}
      role="region"
      aria-describedby="dialog1BusinessDesc dialog2BusinessDesc"
    >
      <div style={{ outline: 'none' }} id="modalSave">
        <Card sx={classes.rootConti}>
          <CardContent sx={classes.card_content_simple}>
            <>
              <Box component="span" sx={classes.imgSize}>
                <img src={modalIcon} alt="modal icon" />
              </Box>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                }}
              >
                <Typography
                  sx={[classes.textStyleConfirmModal, classes.simpleCard_below_img]}
                  id="dialog1BusinessDesc"
                >
                  {t('Your application is saved.', {
                    defaultValue: 'Your application is saved.',
                  })}
                </Typography>
                <Typography
                  sx={[classes.textStyleConfirmModal, classes.simpleCard_above_btn]}
                  id="dialog1BusinessDesc"
                >
                  {t('You can continue your process.', {
                    defaultValue: 'You can continue your process.',
                    nsSeparator: '|',
                  })}
                </Typography>
              </div>
              <Grid container sx={classes.simple_Modal}>
                <Grid size={{ xs: 12 }}>
                  <Button
                    disableFocusRipple
                    variant="outlined"
                    sx={classes.saveAndExit_Confirm}
                    data-testid="CloseTryButtonInBusinessModal"
                    onClick={handleConti}
                  >
                    {t('Continue', { defaultValue: 'Continue' })}
                  </Button>
                </Grid>
              </Grid>
            </>
          </CardContent>
        </Card>
      </div>
    </Modal>
  );
};
export default withRouter(SimpleTextModal);
